<template>
    <div >
    <!--    <b-overlay :show="comments==null" rounded="sm" opacity="0.50 " variant="white"> -->
           
               <!-- 
            <div class="table-overflow overflow-auto overflow">
                <table id="dt-opt" class="table table-lg table-striped text-center font-weight-light">
                    <thead>
                        <tr>
                            <th></th>
                            <th> Type de commentaire </th> 
                            <th> Commentaire </th> 
                            <th> Utilisateur </th>
                            <th> Compteur </th>
                            <th> Date </th> 
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(comment, index) in comments" v-bind:key="comment.id">
                            <td> {{index+1}} </td>
                            <td class="align-middle" > {{comment.commentType}} </td>
                            <td class="align-middle" > {{comment.TXT_Value}} </td>
                            <td class="align-middle" > {{comment.user.lastname}} {{comment.user.firstname}} </td>
                            <td class="align-middle pointer" @click='sensor_popup_open(comment.sensor)'> 
                                <a href=""></a> {{comment.sensor.name}}
                                </td>
                            <td class="align-middle" > {{comment.created_at}}</td>
                        </tr>
                    </tbody>
                </table> 
            </div>-->  
                <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Saisissez votre recherche"
                ></b-form-input>

                <b-table sticky-header class="Tableheight" small
                :busy='comments==null' 
                        :items="items"
                        :fields="fields"
                        :filter="filter" 
                        :per-page="perPage"
                        :current-page="currentPage"
                        @filtered="onFiltered"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc">
                        <template #table-busy>
                            <div class="text-center text-info my-2">
                                 <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>

                    </b-table> 
                    
                    <div class="col-md-12 mt-4 mb-2">
                        <div class="row">
                            
                            <div class="col-md-4 text-left m-auto">
                                <b-button class="col-md-5 m-auto pointer text-dark bg-transparent border-0" @click="[page=1,ChangePage()]" ><u>Première page</u></b-button >
                                <b-button class="col-md-6 m-auto" @click="[page--,ChangePage()]"  v-if="CurrentPage>1" >Précedent</b-button>
                            </div>

                            <div class="col-md-4 text-center m-auto p-2">
                                <h6 v-if="NbPageMAx" class="m-auto">    
                                    Page : 
                                    <input type="text" v-on:keyup.enter="ChangePage" pattern="[0-9]" min="1" :max="NbPageMAx" v-model="page" class="page col-3"> 
                                    / {{NbPageMAx}}</h6>
                            </div>

                            <div class="col-md-4 text-right m-auto" >
                                <b-button class="col-md-6 m-auto" @click="[page++,ChangePage()]" v-if="CurrentPage!=NbPageMAx&&NbPageMAx>0">Suivant</b-button>
                                <b-button class="col-md-5 m-auto pointer text-dark bg-transparent border-0" @click="[page=NbPageMAx,ChangePage()]" ><u>Dernière page</u></b-button>
                            </div>

                        </div>
                    </div> 
      <!--  </b-overlay> -->
    </div>
</template>
<script>

    import api from "../../config/_api";
export default {
    name:"Sytem_comments",
    data(){
        return {
            sortBy :'Date',
            sortDesc : true,
            selected_sensor: null,
            comments : null,
            Nbcomments : 0 ,
            NbTotalComments:0,
            error : false,
            fields :[
              /*  {key :'Index' ,sortable: true,thClass: 'text-center',tdClass: 'text-center' } ,*/
                {key :'Type_de_commentaire' , sortable: true ,thClass: 'text-center',tdClass: 'text-center'},
                {key :'Valeur' ,sortable: true,thClass: 'text-center',tdClass: 'text-center' } ,
                {key :'Commentaire' ,sortable: true,thClass: 'text-center',tdClass: 'text-center' } ,
                {key :'Utilisateur',sortable: true,thClass: 'text-center',tdClass: 'text-center'},
              /*  {key :'Compteur',sortable: true,thClass: 'text-center',tdClass: 'text-center'},*/
                {key :'Date',sortable: true,thClass: 'text-center',tdClass: 'text-center'}
            ],
            take : 50,
            page : 1, 
            CurrentPage : 1,

            perPage: 10,
            rows: 1,
            filter: null,
        }
    },
    props : {
        system : {
                type: Object,
                required: true,
        }
    },
    watch : {
        page(){
            /*
            OldVal=this.CheckNbPage(OldVal);
            newVal=this.CheckNbPage(newVal);


                this.page=newVal;
                 setTimeout(() => {

                     this.CurrentPage=this.page;
                     if(this.page!=OldVal){
                     this.comments=null;
                     this.getComments();
                     }
                     }, 1000); 
                */
                    
            }
    },

    computed:{
        NbPageMAx(){
            if(this.NbTotalComments==0) return 0 ;
            var max = Math.round(parseInt(this.NbTotalComments) / parseInt(this.take) );
            return max+1;
        },
        skip (){
            return (this.CurrentPage-1)*this.take;
            },
        items(){
            if(this.comments!=null){
                var $items=[];
                var skip=this.skip;
                this.comments.forEach(function (comment, index) {
                    if(comment.sensor == null){
                        comment.sensor = {name:"NA"}
                    }
                    $items.push({
                        Index : skip+index+1,
                        Type_de_commentaire : comment.commentType.title,
                        Commentaire : comment.TXT_Value ,  
                        Utilisateur: comment.user.lastname+" "+comment.user.firstname ,
                        Compteur : comment.sensor.name ,
                        Date : comment.created_at,
                        Valeur : (comment.commentType.shortUnitTitle == '') ? '' : comment['SValue-4'] + " "+ comment.commentType.shortUnitTitle
                        });
                });
/*              //Si on mettais le nombre de commentaire dans index
                for (var comment of this.comments){
                     $items.push(
                    {
                    Type_de_commentaire : comment.commentType ,
                    Commentaire : comment.TXT_Value ,  
                    Utilisateur: comment.user.lastname+" "+comment.user.firstname ,
                    Compteur : comment.sensor.name ,
                    Date : comment.created_at
                    }
                );
                }*/
               
            return $items;
            }
            return null;
        }
    },
    created(){
        this.NbTotalComments=this.system.NbComments;
        this.getComments();
    },

    methods: {
        ChangePage(){
            this.page=this.CheckNbPage(this.page);
            this.CurrentPage=this.CheckNbPage(this.CurrentPage);
            if(this.page!=this.CurrentPage){
                this.CurrentPage=this.page;
                this.comments=null;
                this.getComments();
            }  
        },
        CheckNbPage(Val){
            
            if((typeof Val) =="number"){
                Val=Val.toString();
            }
            
            Val=Val.replace(/[^\d]/g, "");

            if(Val<1) {   
                Val=1;}

            else if(Val>this.NbPageMAx){
                Val=this.NbPageMAx;}
            
            return Val;

        },
        sensor_popup_open(sensor){
            this.selected_sensor=sensor
        },

        getComments(){
            let data='system_id='+this.system.id+'&skip='+this.skip+'&take='+this.take;
            
            this.axios({url: api.url + 'systems/comments?'+data, data: null, method: 'GET' })
                    .then(resp => {
                        this.comments=resp.data.comments;
                        this.Nbcomments=this.comments.length;
                        this.error = false;
                })
                .catch(err => {
                    this.error = true;
                    //console.log(err);
                });
        },
        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
        },
    }
}
</script>

<style>
.page{
    border: 1px solid #e6ecf5;
    border-radius: 2px;
    -webkit-box-shadow: none;
    box-shadow: none;
    height: 42px;
    font-size: 14px;
    color: #888da8;
    }
    .Tableheight{
        height: 700px !important;
    }
</style>